import React from 'react';
import { getAvatar, type Mood } from '../Assets/Avatars';
import { useAvatar } from '../context/AvatarContext';

interface Props {
  size?: number;
  mood?: Mood;
  /** Mirror the SVG horizontally (the source SVGs face left). */
  facing?: 'left' | 'right';
  style?: React.CSSProperties;
  title?: string;
}

const AvatarImg: React.FC<Props> = ({
  size = 64,
  mood = 'idle',
  facing = 'left',
  style,
  title,
}) => {
  const { character } = useAvatar();
  if (!character) return null;
  const flip = facing === 'right' ? -1 : 1;
  return (
    <img
      src={getAvatar(character, mood)}
      alt={`${character} avatar`}
      title={title}
      width={size}
      height={size}
      draggable={false}
      style={{
        width: size,
        height: size,
        transform: `scaleX(${flip})`,
        transformOrigin: 'center center',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        ...style,
      }}
    />
  );
};

export default AvatarImg;
